/**************************************************
 * Nombre:       Dialogo_Formulario_Interactivo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {usePasosFormularios} from "../../Modulo_Pasos/Hooks/usePasosFormularios";
import {useState} from "react";
import Formulario_Inter_Area from "../Formularios/Formulario_Inter_Area";
import Formulario_Formacion from "../Formularios/Formulario_Formacion";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Dialogo_Formulario_Interactivo = ({datos}) => {
    const {sCell} = useResponsive()
    const {Pasos} = usePasosFormularios({
        datos: datos,
        formularios: [
            Formulario_Inter_Area,
            Formulario_Formacion
        ],

    })
    const [cargando, setCargando] = useState({})

    const finalizar = (e) => {

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 2}}
        >

            <Pasos cargando={cargando} finalizar={finalizar}/>

        </Grid>
    )

}
export default Dialogo_Formulario_Interactivo